<template>
  <div class="balloon balloon-quick" @click.shift.left.exact="bubbleShift">
    <div class="quick-template">
      <div v-for="(button, j) in message.payload.buttons" :key="j">
        {{ button.title }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PayloadQuickReply',
  props: {
    conversation: Object
  },
  data() {
    return {
      message: {},
      sender: ''
    }
  },
  watch: {
    conversation: {
      immediate: true,
      handler() {
        this.message = this.conversation.message
        this.sender = this.conversation.sender
      }
    }
  },
  methods: {
    bubbleShift(e) {
      this.$emit('debugPopup', this.conversation)
    }
  }
}
</script>
